import * as actions from '../constants/actions'
import { createReducer, perKeyReducer } from '../utils/redux'
import { arrayToObject } from '../utils/misc'

const LOADING = 'LOADING'
const SUCCESS = 'SUCCESS'
const ERROR = 'ERROR'
const MISSING = 'MISSING'

const heavyStompunkterReducer = createReducer({}, {

	[actions.LOAD_HEAVY_STOMPUNKTER_REQUEST]: (state, action) => {
		const updates = action.ids.map((id) => ({
			id,
			status: LOADING
		}))
		return updateStompunkter(state, updates)
	},

    [actions.LOAD_HEAVY_STOMPUNKTER_SUCCESS]: (state, action) => {
    	const updates = action.ids.map((id) => ({
    		id: id,
    		data: action.stompunkter.heavySystem[id],
    		status: action.stompunkter.heavySystem[id] ? SUCCESS : MISSING
    	}))
    	return updateStompunkter(state, updates)
    },

    [actions.LOAD_HEAVY_STOMPUNKTER_ERROR]: (state, action) => {
        const updates = action.ids.map((id) => ({
        	id,
        	status: ERROR
        }))
        return updateStompunkter(state, updates)
    }

})

function updateStompunkter(oldStompunkter, updates) {
	return {
		...oldStompunkter,
		...arrayToObject(updates, 'id')
	}
}

export default perKeyReducer('srid', heavyStompunkterReducer)



// WEBPACK FOOTER //
// ./src/reducers/heavyStompunkter.js